import {client} from "@/httpClient";
import {createFileRoute} from "@tanstack/react-router";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {useTitle} from "react-use";

export const Route = createFileRoute("/_authenticated/_admin/admins/bulk-sms")({
  component: BulkSms,
});

function BulkSms() {
  const {t} = useTranslation("navigation");

  useTitle(t("bulk_sms"));

  const [failure, setFailure] = useState(false);
  const [failedNumbers, setFailedNumbers] = useState([]);
  const [message, setMessage] = useState("");
  const [numbers, setNumbers] = useState("");
  const [success, setSuccess] = useState(false);

  return (
    <div className="py-8 lg:pb-20">
      <div className="max-w-wide relative z-20 mx-auto px-5 md:px-8">
        <div className="flex">
          <div className="flex-1">
            <div className="mb-16 flex flex-col items-start rounded-3xl bg-white p-5 shadow-lg">
              <div>
                <h2 className="-mt-3 mb-2">Bulk Sms</h2>
              </div>
              <div className="mb-4 w-full">
                <form className="-mx-2.5 flex flex-wrap">
                  <div className="mx-2.5 mb-6 flex grow flex-col flex-wrap">
                    <label
                      htmlFor="name"
                      className="text-good-grey-500 mt-4 block text-xs font-semibold tracking-wider uppercase">
                      New line separated numbers
                    </label>
                    <textarea
                      className="shadow-highlight focus:outline-good-grey-100 mb-1.5 block w-full resize-y rounded-2xl bg-white p-2 text-gray-500 focus:shadow-none focus:outline-2 focus:-outline-offset-1"
                      placeholder="New line separated numbers"
                      value={numbers}
                      onChange={event => setNumbers(event.target.value)}
                    />
                  </div>
                  <div className="mx-2.5 mb-6 flex basis-full flex-col flex-wrap md:basis-2/5">
                    <label
                      htmlFor="name-4"
                      className="text-good-grey-500 mt-4 block text-xs font-semibold tracking-wider uppercase">
                      Message
                    </label>
                    <input
                      type="text"
                      className="shadow-highlight focus:outline-good-grey-100 mb-1.5 block w-full resize-y rounded-2xl bg-white p-2 text-gray-500 focus:shadow-none focus:outline-2 focus:-outline-offset-1"
                      placeholder="Message"
                      value={message}
                      onChange={event => setMessage(event.target.value)}
                    />
                  </div>
                </form>
                {success && (
                  <div>
                    {failedNumbers.length === 0 ? (
                      <div>Bulk sms sent successfully!</div>
                    ) : (
                      <div>
                        Sms could not be sent on the following numbers.
                        <ul>
                          {failedNumbers.map((number, index) => (
                            <li key={index}>{number}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                )}
                {failure && (
                  <div>
                    <div>Bulk sms could not be sent!</div>
                  </div>
                )}
              </div>
              <button
                className="bg-bold-blue-500 hover:shadow-highlight mr-2.5 min-h-10 min-w-10 cursor-pointer rounded-2xl border-none px-5 py-3 text-center font-medium tracking-wider text-white uppercase hover:scale-105"
                onClick={event => {
                  event.preventDefault();
                  client
                    .post(`/users/bulk_sms/`, {
                      numbers: numbers.trimEnd(),
                      message: message,
                    })
                    .then(response => {
                      setSuccess(true);
                      setFailure(false);
                      setFailedNumbers(response.data.failed_numbers);
                    })
                    .catch(() => {
                      setSuccess(false);
                      setFailure(true);
                    });
                }}>
                Send bulk sms
              </button>
            </div>
            <button
              className="bg-good-grey-100 text-neutral-black-dark hover:shadow-highlight mr-2.5 mb-4 min-h-10 min-w-10 cursor-pointer rounded-2xl border-none px-5 py-3 text-center font-medium tracking-wider uppercase hover:scale-105"
              onClick={event => {
                event.preventDefault();
                client.defaults.xsrfCookieName = "csrftoken";
                client.defaults.xsrfHeaderName = "X-CSRFTOKEN";
                client
                  .get(`/logs/force_log_upload/`, {})
                  .then(() => {})
                  .catch(error => {
                    console.log(error);
                  });
              }}>
              Force log update
            </button>
            <button
              className="bg-good-grey-100 text-neutral-black-dark hover:shadow-highlight mr-2.5 mb-4 min-h-10 min-w-10 cursor-pointer rounded-2xl border-none px-5 py-3 text-center font-medium tracking-wider uppercase hover:scale-105"
              onClick={event => {
                event.preventDefault();
                client.defaults.xsrfCookieName = "csrftoken";
                client.defaults.xsrfHeaderName = "X-CSRFTOKEN";
                client
                  .get(`/logs/raise_exception/`, {})
                  .then(() => {})
                  .catch(error => {
                    console.log(error);
                  });
              }}>
              Force exception
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
